export const REQUEST = 'REQUEST'
export const SUCCESS = 'SUCCESS'
export const ERROR = 'ERROR'
export const SWITCH = 'SWITCH'
export const UPLOADED_FILE = 'UploadedFile'
export const RASA_API = 'RASA_API'
export const RASA_INTEGRATIONS_API = 'RASA_INTEGRATIONS_API'
export const LINK_SHORTEN = 'LINK_SHORTEN'



// WEBPACK FOOTER //
// ./src/request/constants.ts